import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useAuth } from "../context/AuthContext";
import { useUserPlan } from "../context/UserPlanContext";
import { tender360Api } from "./tender360Api";
import { resetTender360Views } from "./tender360ViewsSlice";

const normalizeScopeValue = (value) => {
  if (Array.isArray(value)) {
    return value.map(normalizeScopeValue).sort((left, right) =>
      JSON.stringify(left).localeCompare(JSON.stringify(right)),
    );
  }
  if (value && typeof value === "object") {
    return Object.keys(value)
      .sort()
      .reduce((result, key) => {
        result[key] = normalizeScopeValue(value[key]);
        return result;
      }, {});
  }
  return value;
};

const stablePlanSignature = (value) => {
  if (!value) return "";
  try {
    return JSON.stringify(normalizeScopeValue(value));
  } catch (_error) {
    return String(value);
  }
};

const Tender360SessionBoundary = ({ children }) => {
  const dispatch = useDispatch();
  const { userId, isLoading } = useAuth();
  const { planFilters } = useUserPlan();
  const previousScope = useRef(null);
  const [scopeVersion, setScopeVersion] = useState(0);
  const planSignature = stablePlanSignature(planFilters);

  useEffect(() => {
    if (isLoading) return;
    const nextScope = `${userId || "guest"}:${planSignature}`;
    if (previousScope.current === null) {
      previousScope.current = nextScope;
      return;
    }
    if (previousScope.current === nextScope) return;

    previousScope.current = nextScope;
    dispatch(tender360Api.util.resetApiState());
    dispatch(resetTender360Views());
    setScopeVersion((version) => version + 1);
  }, [dispatch, isLoading, planSignature, userId]);

  return <React.Fragment key={scopeVersion}>{children}</React.Fragment>;
};

export default Tender360SessionBoundary;
